module.exports = __webpack_public_path__ + "static/kell-circle-low.99371677.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/kell-circle-low.jpg
// module id = 883
// module chunks = 169928946856436